import { useCallback } from "react";
import { useSearchParams } from "react-router";
import {
  BonificoOrderSortField,
  BonificoOrdersFilters,
  SortDirection,
} from "../../ProductService/BonificoOrder/BonificoOrdersListQuery.ts";
import {
  parseBonificoOrdersListQuery,
  withBonificoOrdersFilters,
  withBonificoOrdersPage,
  withBonificoOrdersSearch,
  withBonificoOrdersSort,
} from "./bonificoOrdersListUrlState.ts";

export function useBonificoOrdersListUrlState() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = parseBonificoOrdersListQuery(searchParams);

  const setSearch = useCallback(
    (search: string) =>
      setSearchParams((current) => withBonificoOrdersSearch(current, search)),
    [setSearchParams],
  );

  const setSort = useCallback(
    (sortBy: BonificoOrderSortField, sortDirection: SortDirection) =>
      setSearchParams((current) =>
        withBonificoOrdersSort(current, sortBy, sortDirection),
      ),
    [setSearchParams],
  );

  const setFilters = useCallback(
    (filters: BonificoOrdersFilters) =>
      setSearchParams((current) => withBonificoOrdersFilters(current, filters)),
    [setSearchParams],
  );

  const toPage = useCallback(
    (pageIndex: number) =>
      setSearchParams((current) => withBonificoOrdersPage(current, pageIndex)),
    [setSearchParams],
  );

  return { query, setSearch, setSort, setFilters, toPage };
}
